import { Button, Flex, Icon, Text, Title } from '@brokerbay/elements-web';
import { Modal } from 'components';
import moment from 'moment';
import React, { useContext } from 'react';
import styled from 'styled-components';
import BookingTimeSelectContext from './BookingTimeSelectContext';

const RestrictedTimeModal: React.FC = () => {
  const {
    comingSoonWarningData,
    earliestBookingDateAllowed,
    setComingSoonWarningData,
  } = useContext(BookingTimeSelectContext);

  return (
    <Modal
      title={
        <Flex gap="middle" align="center">
          <Icon icon="warningOutlined" size={24} color="warning" />
          <StyledTitle level={3} dataCy="comingSoonWarningModal-title">
            Book Showing
          </StyledTitle>
        </Flex>
      }
      footer={
        <Flex justify="space-around">
          <Button
            dataCy="cancelComingSoonWarning-btn"
            type="secondary"
            onClick={() =>
              setComingSoonWarningData({ isModalOpen: false, onOk: () => null })
            }
          >
            Cancel
          </Button>{' '}
          <Button
            dataCy="continueComingSoonWarning-btn"
            onClick={comingSoonWarningData.onOk}
          >
            Continue
          </Button>
        </Flex>
      }
      centered
      closable={false}
      open={comingSoonWarningData.isModalOpen}
      data-cy="comingSoonWarning-modal"
    >
      <StyledText size="large">
        This listing will be active on{' '}
        {moment(earliestBookingDateAllowed).format('MMM D, YYYY')}. Are you sure
        you&apos;d like to book a showing before it goes live?
      </StyledText>
    </Modal>
  );
};

const StyledTitle = styled(Title)`
  && {
    margin: 0;
  }
`;

const StyledText = styled(Text)`
  text-align: center;
`;

export default RestrictedTimeModal;
